import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AboutCircle from "./BgAnimations/AboutCircle";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  useEffect(() => {
    // Set initial state - all words grey
    gsap.set(".word", { color: "#606060" });

    // Detect mobile device
    const isMobile = window.innerWidth <= 768;

    // Create scroll-triggered color reveal animation with mobile-friendly settings
    gsap.to(".word", {
      scrollTrigger: {
        trigger: ".about-text",
        start: isMobile ? "top 90%" : "top 80%",
        end: isMobile ? "bottom 70%" : "bottom 60%",
        scrub: isMobile ? 0.5 : 1,
        markers: false,
        // Refresh on resize for responsive behavior
        refreshPriority: 1,
        // Force refresh on mobile for better performance
        invalidateOnRefresh: true,
      },
      color: "#fff",
      stagger: 0.05,
      ease: "none",
    });

    // Force ScrollTrigger refresh on mobile
    if (isMobile) {
      ScrollTrigger.refresh();
    }

    // Cleanup function to kill ScrollTrigger instances
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <section className="section about-section">
      <div className="about-content">
        <div className="about-text-container">
          <h2 className="about-text">
            <span className="word">At </span>
            <span className="word">Atomik, </span>
            <span className="word">Your </span>
            <span className="word">ideas </span>
            <span className="word">turn </span>
            <span className="word">into </span>
            <span className="word">powerful </span>
            <span className="word">systems, </span>
            <span className="word">fast. </span>
            <span className="word">We </span>
            <span className="word">build </span>
            <span className="word">with </span>
            <span className="word">AI </span>
            <span className="word">components </span>
            <span className="word">that </span>
            <span className="word">are </span>
            <span className="word">robust, </span>
            <span className="word">adaptive, </span>
            <span className="word">and </span>
            <span className="word">built </span>
            <span className="word">for </span>
            <span className="word">scale. </span>
            <span className="word">Just </span>
            <span className="word">plug </span>{" "}
            <span className="word">in </span>
            <span className="word">the </span>
            <span className="word">right </span>
            <span className="word">pieces, </span>
            <span className="word">and </span>
            <span className="word">watch </span>
            <span className="word">your </span>
            <span className="word">ideas </span>
            <span className="word">turn </span>
            <span className="word">into </span>
            <span className="word">intelligent </span>
            <span className="word">systems.</span>
          </h2>
        </div>
        <div className="about-animation">
          <AboutCircle />
        </div>
      </div>
    </section>
  );
};

export default About;
